import { InsuranceDetails } from 'Api/insurance';
import { ProductName } from 'Constants/products.constants';
import { ChangeFormValues } from 'Forms/ChangeForm/changeForm.types';
import { getAppText } from 'Utils/text';
import { CancelFormValues } from '../cancelForm.types';
import { getSubmitSuccessDescriptionTravel } from '../products/travel/cancelTravelForm.helpers';

export const getSubmitSuccessDescription = (
  insurance: InsuranceDetails,
  formValues: CancelFormValues | ChangeFormValues,
): string => {
  switch (insurance.insuranceProduct) {
    case ProductName.ELECTRIC_SCOOTER:
      return getAppText(
        'changeInsurance.electricScooter.alert.submitted.description',
      );
    case ProductName.TRAVEL:
    case ProductName.AKA_HOUSE_CONTENTS:
      return getSubmitSuccessDescriptionTravel(
        formValues,
        insurance.renewalDate,
      );
    default:
      return '';
  }
};
